import LoadingEllipsis from "./LoadingEllipsis";
import LoadingSpinner from "./LoadingSpinner";
import type { FullScreenLoaderProps } from "./types";

const FullScreenSpinner = (props: FullScreenLoaderProps) => {
  const { type = "spinner", overlay } = props;
  return (
    <>
      <div
        style={{
          position: "fixed",
          left: "0",
          top: "50%",
          zIndex: "50",
          width: "100%",
          transform: "translateY('50%)", // TODO: double check this
        }}
      >
        {type === "spinner" && <LoadingSpinner {...props} />}
        {type === "ellipsis" && <LoadingEllipsis {...props} />}
      </div>
      {props.overlay && (
        <div
          style={{
            position: "fixed",
            left: "0",
            top: "0",
            zIndex: "40",
            width: "100%",
            height: "100%",
            backgroundColor: "gray",
          }}
          className={` ${
            overlay?.bgColor ? overlay.bgColor : "bg-ToneBlue" // TODO: set this to MUI color
          } ${overlay?.opacity ? overlay.opacity : "opacity-20"} `} // TODO: set this to a constant
        ></div>
      )}
    </>
  );
};

export default FullScreenSpinner;
